module.exports = __webpack_public_path__ + "static/media/align.ea7fc72f.svg";